import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Modal from "components/Modal";
import ModalClose from "components/ModalClose";
import ModalContent from "components/ModalContent";
import { modalStyleProp } from "helpers/modalStyles";
const LOGIN_PROMPT_STYLE = {
    ...modalStyleProp(),
    content: {
        ...modalStyleProp().content,
        width: "90vw",
        maxWidth: "480px",
        right: "auto",
        borderRadius: "12px",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.18)",
    },
    overlay: {
        ...modalStyleProp().overlay,
        zIndex: 1200,
    },
};
const LoginPromptModal = ({ isOpen, onClose, contentLabel, children, }) => (_jsxs(Modal, { isOpen: isOpen, contentLabel: contentLabel, customStyle: LOGIN_PROMPT_STYLE, children: [_jsx(ModalClose, { closeAction: onClose }), _jsx(ModalContent, { body: (_jsx("div", { "data-testid": "modal-content-body", children: children })), fullWidth: false })] }));
export default LoginPromptModal;
